// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getConfirmPatientHasNoAllergyEndPoint = (patientId) =>
  `api/v1/patients/${patientId}/allergies/confirmnoallergy`

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getUnConfirmPatientHasNoAllergyEndPoint = (patientId) =>
  `api/v1/patients/${patientId}/allergies/unconfirmnoallergy`

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const chancelVisitEndpoint = (visitId) => `api/v1/visits/${visitId}/cancel`

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const getPatientsListEndpoint = ({ count, offSet, encodedSearchValue, birthDate }) =>
  `api/v1/patients?Count=${count}&Offset=${offSet}&SearchValue=${encodedSearchValue}&BirthDate=${birthDate}`

export const createProviderEndpoint = () => 'api/v1/providers'
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getEditProviderEndpoint = (id) => `api/v1/providers/${id}`
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getMediaFileEndpoint = (patientId, fileId) => `api/v1/patients/${patientId}/mediafiles/${fileId}`
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setMediaFileTagsEndpoint = (patientId, fileId) => `api/v1/patients/${patientId}/mediafiles/${fileId}`
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getPatientInfoEndpoint = (patientId) => `api/v1/patients/${patientId}`

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const updateStateSettingsEndpoint = (stateCode) => `api/v1/settings/${stateCode}`
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getIDVerificationEndpoint = (patientId) => `api/v1/patients/${patientId}/identityverification`
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const manuallyVerifyPatientEndpoint = (patientId) => `api/v1/patients/${patientId}/identityverification/verify`
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const sendVerificationInviteEndpoint = (patientId) => `api/v1/patients/${patientId}/identityverification/resend`

export const methods = {
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  GET: 'GET',
}

export const apiErrorCodes = {
  LICENSE_VISIT_TYPE_COUNT_NOT_VALID: 'LicenseVisitTypeCountNotValid',
  VISIT_TYPE_NOT_FOUND: 'VisitTypeNotFound',
  PROVIDER_NOT_FOUND: 'ProviderNotFound',
  PRODUCTIVITY_OVERRIDE_NOT_VALID: 'ProductivityOverrideNotValid',
  PHONE_NUMBER_NOT_VALID: 'PhoneNumberNotValid',
  PHONE_NUMBER_NOT_UNIQUE: 'PhoneNumberNotUnique',
  THIRD_PARTY_ERROR: 'ThirdPartyError',
  LICENSE_NOT_UNIQ: 'LicenseNotUnique',
  CREDIT_CARD_NOT_UNIQUE: 'CreditCardNotUnique',
  FILE_NOT_FOUND: 'FileNotFound',
  PERIOD_NOT_VALID: 'PeriodNotValid',
  FILE_TAG_NOT_VALID: 'FileTagNotValid',
  PATIENT_NOT_FOUND: 'PatientNotFound',
  INTERNAL_SEVER_ERROR: 'InternalServerError',
  STATE_CODE_NOT_VALID: 'StateCodeNotValid',
  ID_VERIFICATION_NOT_FOUND: 'IdentityVerificationNotFound',
  FORBIDDEN: 'Forbidden',
  VISIT_RESCHEDULE_NOT_AVAILABLE: 'VisitRescheduleNotAvailable',
  TREATMENT_CENTER_NOT_AVAILABLE: 'TreatmentCenterNotAvailable',
  DATE_TIME_NOT_VALID: 'DateTimeNotValid',
}
